import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next';
import moment from "moment";

// Actions
import { setLoading, getDashboard, getDashboardOnlyWounds, getEstablishments, updateUserViewsDashboard, getDashboardWithoutDiskSpace } from '../../store/actions/login/loginActions';

// CONSTANTS
import { isDefined } from '../../utils/utils';
import { colorsGraphs } from '../../utils/constants';

//OUTSIDE COMPONENTS

//INSIDE COMPONENTS
import DashboardPage from './DashboardPage';
import BackToTop from '../../components/BackToTop';

class DashboardPages extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            spaceUsed: '',
            spaceAll: '',
            acessSettings: false,
            acessWounds: false,
            //data From dashboard request
            idInstitution: "",
            NumberOfUserLicense: 0,
            NumberOfPhotos: 0,
            NumberOfPacientsMen: 0,
            NumberOfPacientsWomen: 0,
            NumberOfWounds: 0,
            NumberOfWoundsOpen: 0,
            NumberOfWoundsClosed: 0,
            NumberOfWoundsAdmission: 0,
            NumberOfMonitorDelay: 0,
            WoundsByType: null,
            WoundsByTypePain: null,
            PacientsWoundsOpenByType: null,
            WoundsByTypeGender: null,
            ListInternmentWounds: null,
            ListWoundsTime: null,
            WoundsByDiagnosis: null,
            InterventionsDelayed: null,
            ListProductsByType: null,
            isLoading: true,
            filterDateFromWounds: moment().add(-1, 'y'),
            filterDateToWounds: moment(),
            establishments: null,
            selectedEstablishments: [],
            getDashboardInProgress: false,
            userViewDiskSpace: true,
            userViewNumberUsers: true,
            userViewUsageLevels: true,
            userViewNrWoundsAdmission: true,
            userViewAverageWounds: true,
            userViewTreatments: true,
            userViewUnhealedWounds: true,
            userViewWoundsHospitalization: true,
            userViewWoundsByType: true,
            userViewTreatmentsAfterDate: true,
            userViewAveragePain: true,
            userViewWoundsTypeDiagnosis: true,
            userViewWoundsTypeGender: true,
            userViewNrDelayedTreatments: true,
            needRefreshDashboard: false
        };

    }

    componentDidMount() {
        if (!this.props.login.needTokenRefresh && this.props.login.validToken) {
            this.setState({
                userViewDiskSpace: this.props.login.userViewDiskSpace,
                userViewNumberUsers: this.props.login.userViewNumberUsers,
                userViewUsageLevels: this.props.login.userViewUsageLevels,
                userViewNrWoundsAdmission: this.props.login.userViewNrWoundsAdmission,
                userViewAverageWounds: this.props.login.userViewAverageWounds,
                userViewTreatments: this.props.login.userViewTreatments,
                userViewUnhealedWounds: this.props.login.userViewUnhealedWounds,
                userViewWoundsHospitalization: this.props.login.userViewWoundsHospitalization,
                userViewWoundsByType: this.props.login.userViewWoundsByType,
                userViewTreatmentsAfterDate: this.props.login.userViewTreatmentsAfterDate,
                userViewAveragePain: this.props.login.userViewAveragePain,
                userViewWoundsTypeDiagnosis: this.props.login.userViewWoundsTypeDiagnosis,
                userViewWoundsTypeGender: this.props.login.userViewWoundsTypeGender,
                userViewNrDelayedTreatments: this.props.login.userViewNrDelayedTreatments
            })
            //obter os estabelecimentos
            this.props.login.establishmentsInProgress = true;
            this.props.getEstablishments();
        }

    }

    componentDidUpdate() {
        const { establishmentsInProgress, institution, getDashboardInProgress, userAcess, establishments, needTokenRefresh, validToken, userViewDiskSpace } = this.props.login;
        if (!needTokenRefresh && validToken) {
            if (!isDefined(establishments) && !establishmentsInProgress) {
                this.props.getEstablishments();
            } else {
                if (!getDashboardInProgress) {
                    /* if (dashboardData.id === "" && !this.state.getDashboardInProgress) {
                        let filter = {
                            From: this.state.filterDateFromWounds,
                            To: this.state.filterDateToWounds,
                            type: this.props.login.userAcess.wounds && this.props.login.userAcess.settings ? "ALL" : "GLOBAL"
                        }
                        this.setState({ getDashboardInProgress: true })
                        if (userAcess.settings) {
                            this.props.login.getDashboardInProgress = true;
                            this.props.getDashboard(filter);
                        } else {
                            this.props.login.getDashboardInProgress = true;
                            this.props.getDashboardOnlyWounds(filter);
                        }
                    } else */
                    if (institution !== this.state.idInstitution) {
                        let filter = {
                            From: this.state.filterDateFromWounds,
                            To: this.state.filterDateToWounds,
                            type: this.props.login.userAcess.wounds && this.props.login.userAcess.settings ? "ALL" : "GLOBAL",
                            establishments: this.state.selectedEstablishments
                        }
                        if (userAcess.settings) {
                            this.props.login.getDashboardInProgress = true;
                            if (userViewDiskSpace) {
                                this.props.getDashboard(filter);
                            } else {
                                this.props.getDashboardWithoutDiskSpace(filter);
                            }
                        } else {
                            this.props.login.getDashboardInProgress = true;
                            this.props.getDashboardOnlyWounds(filter);
                        }
                    } else if (this.state.needRefreshDashboard) {
                        let filter = {
                            From: this.state.filterDateFromWounds,
                            To: this.state.filterDateToWounds,
                            type: this.props.login.userAcess.wounds && this.props.login.userAcess.settings ? "ALL" : "GLOBAL",
                            establishments: this.state.selectedEstablishments
                        }
                        if (userAcess.settings) {
                            this.props.login.getDashboardInProgress = true;
                            if (userViewDiskSpace) {
                                this.props.getDashboard(filter);
                            } else {
                                this.props.getDashboardWithoutDiskSpace(filter);
                            }
                        } else {
                            this.props.login.getDashboardInProgress = true;
                            this.props.getDashboardOnlyWounds(filter);
                        }
                    } else if (this.state.isLoading) {
                        this.setState({ isLoading: false, getDashboardInProgress: false })
                    }
                }
            }
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        //A validação deve ser efetuada pelos que têm mais probabilidade de alterar em primeiro lugar...
        if (nextProps.login.dashboardData.NumberOfPhotos !== prevState.NumberOfPhotos || nextProps.login.dashboardData.NumberOfWounds !== prevState.NumberOfWounds ||
            nextProps.login.dashboardData.NumberOfWoundsAdmission !== prevState.NumberOfWoundsAdmission ||
            nextProps.login.dashboardData.NumberOfWoundsOpen !== prevState.NumberOfWoundsOpen || nextProps.login.dashboardData.NumberOfWoundsClosed !== prevState.NumberOfWoundsClosed ||
            nextProps.login.dashboardData.NumberOfPacientsMen !== prevState.NumberOfPacientsMen || nextProps.login.dashboardData.NumberOfPacientsWomen !== prevState.NumberOfPacientsWomen ||
            nextProps.login.dashboardData.id !== prevState.idInstitution || nextProps.login.dashboardData.NumberOfUserLicense !== prevState.NumberOfUserLicense ||
            nextProps.login.dashboardData.NumberOfMonitorDelay !== prevState.NumberOfMonitorDelay || nextProps.login.dashboardData.WoundsByType !== prevState.WoundsByType ||
            nextProps.login.dashboardData.WoundsByTypePain !== prevState.WoundsByTypePain || nextProps.login.dashboardData.PacientsWoundsOpenByType !== prevState.PacientsWoundsOpenByType ||
            nextProps.login.dashboardData.WoundsByTypeGender !== prevState.WoundsByTypeGender || nextProps.login.dashboardData.ListInternmentWounds !== prevState.ListInternmentWounds ||
            nextProps.login.dashboardData.ListWoundsTime !== prevState.ListWoundsTime || nextProps.login.dashboardData.WoundsByDiagnosis !== prevState.WoundsByDiagnosis ||
            nextProps.login.dashboardData.InterventionsDelayed !== prevState.InterventionsDelayed || nextProps.login.dashboardData.ListProductsByType !== prevState.ListProductsByType ||
            nextProps.login.userAcess.settings !== prevState.acessSettings || nextProps.login.userAcess.wounds !== prevState.acessWounds ||
            nextProps.login.spaceUsed !== prevState.spaceUsed || nextProps.login.spaceAll !== prevState.spaceAll || nextProps.login.establishments !== prevState.establishments ||
            nextProps.login.userViewDiskSpace !== prevState.userViewDiskSpace || nextProps.login.userViewNumberUsers !== prevState.userViewNumberUsers || nextProps.login.userViewUsageLevels !== prevState.userViewUsageLevels ||
            nextProps.login.userViewNrWoundsAdmission !== prevState.userViewNrWoundsAdmission || nextProps.login.userViewAverageWounds !== prevState.userViewAverageWounds || nextProps.login.userViewTreatments !== prevState.userViewTreatments ||
            nextProps.login.userViewUnhealedWounds !== prevState.userViewUnhealedWounds || nextProps.login.userViewWoundsHospitalization !== prevState.userViewWoundsHospitalization || nextProps.login.userViewWoundsByType !== prevState.userViewWoundsByType ||
            nextProps.login.userViewTreatmentsAfterDate !== prevState.userViewTreatmentsAfterDate || nextProps.login.userViewAveragePain !== prevState.userViewAveragePain || nextProps.loginuserViewWoundsTypeDiagnosis !== prevState.loginuserViewWoundsTypeDiagnosis ||
            nextProps.login.userViewWoundsTypeGender !== prevState.userViewWoundsTypeGender || nextProps.login.userViewNrDelayedTreatments !== prevState.userViewNrDelayedTreatments
        ) {
            return {
                acessSettings: nextProps.login.userAcess.settings,
                acessWounds: nextProps.login.userAcess.wounds,
                spaceUsed: nextProps.login.spaceUsed,
                spaceAll: nextProps.login.spaceAll,
                idInstitution: nextProps.login.dashboardData.id,
                NumberOfUserLicense: nextProps.login.dashboardData.NumberOfUserLicense,
                NumberOfPhotos: nextProps.login.dashboardData.NumberOfPhotos,
                NumberOfPacientsMen: nextProps.login.dashboardData.NumberOfPacientsMen,
                NumberOfPacientsWomen: nextProps.login.dashboardData.NumberOfPacientsWomen,
                NumberOfWounds: nextProps.login.dashboardData.NumberOfWounds,
                NumberOfWoundsOpen: nextProps.login.dashboardData.NumberOfWoundsOpen,
                NumberOfWoundsClosed: nextProps.login.dashboardData.NumberOfWoundsClosed,
                NumberOfWoundsAdmission: nextProps.login.dashboardData.NumberOfWoundsAdmission,
                NumberOfMonitorDelay: nextProps.login.dashboardData.NumberOfMonitorDelay,
                WoundsByType: nextProps.login.dashboardData.WoundsByType,
                WoundsByTypePain: nextProps.login.dashboardData.WoundsByTypePain,
                PacientsWoundsOpenByType: nextProps.login.dashboardData.PacientsWoundsOpenByType,
                WoundsByTypeGender: nextProps.login.dashboardData.WoundsByTypeGender,
                ListInternmentWounds: nextProps.login.dashboardData.ListInternmentWounds,
                ListWoundsTime: nextProps.login.dashboardData.ListWoundsTime,
                WoundsByDiagnosis: nextProps.login.dashboardData.WoundsByDiagnosis,
                InterventionsDelayed: nextProps.login.dashboardData.InterventionsDelayed,
                ListProductsByType: nextProps.login.dashboardData.ListProductsByType,
                establishments: nextProps.login.establishments,
                isLoading: (nextProps.login.dashboardData.id == "" ? true : (nextProps.login.userViewDiskSpace && !prevState.userViewDiskSpace ? true : prevState.isLoading)),
                userViewDiskSpace: nextProps.login.userViewDiskSpace,
                userViewNumberUsers: nextProps.login.userViewNumberUsers,
                userViewUsageLevels: nextProps.login.userViewUsageLevels,
                userViewNrWoundsAdmission: nextProps.login.userViewNrWoundsAdmission,
                userViewAverageWounds: nextProps.login.userViewAverageWounds,
                userViewTreatments: nextProps.login.userViewTreatments,
                userViewUnhealedWounds: nextProps.login.userViewUnhealedWounds,
                userViewWoundsHospitalization: nextProps.login.userViewWoundsHospitalization,
                userViewWoundsByType: nextProps.login.userViewWoundsByType,
                userViewTreatmentsAfterDate: nextProps.login.userViewTreatmentsAfterDate,
                userViewAveragePain: nextProps.login.userViewAveragePain,
                userViewWoundsTypeDiagnosis: nextProps.login.userViewWoundsTypeDiagnosis,
                userViewWoundsTypeGender: nextProps.login.userViewWoundsTypeGender,
                userViewNrDelayedTreatments: nextProps.login.userViewNrDelayedTreatments,
                needRefreshDashboard: (nextProps.login.userViewDiskSpace !== prevState.userViewDiskSpace && nextProps.login.userViewDiskSpace && !prevState.userViewDiskSpace ? true : false)
            };
        } else {
            return null;
        }
    }


    handleChange = (name) => date => {
        let refresh = false;
        let DateFrom = this.state.filterDateFromWounds;
        let DateTo = this.state.filterDateToWounds;
        let est = this.state.selectedEstablishments;

        switch (name) {
            case "dateFrom":
                if (date != null && date != "Invalid Date") {
                    if (this.state.filterDateFromWounds !== date) {
                        this.setState({
                            filterDateFromWounds: date,
                            isLoading: true
                        })
                        refresh = true;
                        DateFrom = date;
                    }
                } else {
                    if (this.state.filterDateFromWounds != null) {
                        this.setState({
                            filterDateFromWounds: null,
                            isLoading: true
                        })
                        refresh = true;
                        DateFrom = null;
                    }
                }
                break;
            case "dateTo":
                if (date != null && date != "Invalid Date") {
                    if (this.state.filterDateToWounds !== date) {
                        this.setState({
                            filterDateToWounds: date,
                            isLoading: true
                        })
                        refresh = true;
                        DateTo = date;
                    }
                } else {
                    if (this.state.filterDateToWounds != null) {
                        this.setState({
                            filterDateToWounds: null,
                            isLoading: true
                        })
                        refresh = true;
                        DateTo = null;
                    }
                }
                break;
            case "Est":
                if (date != this.state.selectedEstablishments) {
                    this.setState({
                        selectedEstablishments: date,
                        isLoading: true
                    })
                    est = date;
                    refresh = true;
                }
                break;
            default:
                break;
        }

        if (refresh) {
            let filter = {
                From: DateFrom,
                To: DateTo,
                type: this.props.login.userAcess.wounds && this.props.login.userAcess.settings ? "ALL" : "GLOBAL",
                establishments: est
            }

            if (this.props.login.userAcess.settings) {
                this.props.login.getDashboardInProgress = true;
                if (this.props.login.userViewDiskSpace) {
                    this.props.getDashboard(filter);
                } else {
                    this.props.getDashboardWithoutDiskSpace(filter);
                }
            } else {
                this.props.login.getDashboardInProgress = true;
                this.props.getDashboardOnlyWounds(filter);
            }
        }
    };

    OnClearFilter(type) {
        let refresh = false;
        let DateFrom = this.state.filterDateFromWounds;
        let DateTo = this.state.filterDateToWounds;
        let est = this.state.selectedEstablishments;

        switch (type) {
            case "ALL":
                est = [];
                DateFrom = null;
                DateTo = null;
                refresh = true;
                break;
            case "Dates":
                //DateFrom = moment().add(-1, 'y');
                //DateTo = moment();
                DateFrom = null;
                DateTo = null;
                refresh = true;
                break;
            case "FromDate":
                DateFrom = null;
                refresh = true;
                break;
            case "ToDate":
                DateTo = null;
                refresh = true;
                break;
            default:
                break;
        }

        if (refresh) {
            this.setState({
                filterDateFromWounds: DateFrom,
                filterDateToWounds: DateTo,
                selectedEstablishments: est,
                isLoading: true
            })

            let filter = {
                From: DateFrom,
                To: DateTo,
                type: this.props.login.userAcess.wounds && this.props.login.userAcess.settings ? "ALL" : "GLOBAL",
                establishments: est
            }

            if (this.props.login.userAcess.settings) {
                this.props.login.getDashboardInProgress = true;
                if (this.props.login.userViewDiskSpace) {
                    this.props.getDashboard(filter);
                } else {
                    this.props.getDashboardWithoutDiskSpace(filter);
                }
            } else {
                this.props.login.getDashboardInProgress = true;
                this.props.getDashboardOnlyWounds(filter);
            }
        }
    }


    OnChangeView(type) {
        let value = false;
        switch (type) {
            case "userViewAllGlobal":
                if (this.state.userViewDiskSpace && this.state.userViewNumberUsers && this.state.userViewUsageLevels) {
                    value = false;
                } else {
                    value = true;
                }
                //this.setState({ userViewDiskSpace: value, userViewNumberUsers: value, userViewUsageLevels: value, /* needRefreshDashboard: value */ });
                this.props.updateUserViewsDashboard(type, value);
            case "userViewDiskSpace":
                value = !this.state.userViewDiskSpace;
                //this.setState({ userViewDiskSpace: value, /* needRefreshDashboard: value  */ });
                this.props.updateUserViewsDashboard(type, value);

                break;
            case "userViewNumberUsers":
                value = !this.state.userViewNumberUsers;
                //this.setState({ userViewNumberUsers: value });
                this.props.updateUserViewsDashboard(type, value);
                break;
            case "userViewUsageLevels":
                value = !this.state.userViewUsageLevels;
                //this.setState({ userViewUsageLevels: value });
                this.props.updateUserViewsDashboard(type, value);
                break;
            case "userViewAllClinical":
                if (this.state.userViewNrWoundsAdmission && this.state.userViewAverageWounds && this.state.userViewTreatments && this.state.userViewUnhealedWounds &&
                    this.state.userViewWoundsHospitalization && this.state.userViewWoundsByType && this.state.userViewTreatmentsAfterDate && this.state.userViewAveragePain &&
                    this.state.userViewWoundsTypeDiagnosis && this.state.userViewWoundsTypeGender && this.state.userViewNrDelayedTreatments) {
                    value = false;
                } else {
                    value = true;
                }
                /* this.setState({
                    userViewNrWoundsAdmission: value,
                    userViewAverageWounds: value,
                    userViewTreatments: value,
                    userViewUnhealedWounds: value,
                    userViewWoundsHospitalization: value,
                    userViewWoundsByType: value,
                    userViewTreatmentsAfterDate: value,
                    userViewAveragePain: value,
                    userViewWoundsTypeDiagnosis: value,
                    userViewWoundsTypeGender: value,
                    userViewNrDelayedTreatments: value
                }); */
                this.props.updateUserViewsDashboard(type, value);
                break;
            case "userViewNrWoundsAdmission":
                value = !this.state.userViewNrWoundsAdmission;
                //this.setState({ userViewNrWoundsAdmission: value });
                this.props.updateUserViewsDashboard(type, value);
                break;
            case "userViewAverageWounds":
                value = !this.state.userViewAverageWounds;
                //this.setState({ userViewAverageWounds: value });
                this.props.updateUserViewsDashboard(type, value);
                break;
            case "userViewTreatments":
                value = !this.state.userViewTreatments;
                //this.setState({ userViewTreatments: value });
                this.props.updateUserViewsDashboard(type, value);
                break;
            case "userViewUnhealedWounds":
                value = !this.state.userViewUnhealedWounds;
                //this.setState({ userViewUnhealedWounds: value });
                this.props.updateUserViewsDashboard(type, value);
                break;
            case "userViewWoundsHospitalization":
                value = !this.state.userViewWoundsHospitalization;
                //this.setState({ userViewWoundsHospitalization: value });
                this.props.updateUserViewsDashboard(type, value);
                break;
            case "userViewWoundsByType":
                value = !this.state.userViewWoundsByType;
                //this.setState({ userViewWoundsByType: value });
                this.props.updateUserViewsDashboard(type, value);
                break;
            case "userViewTreatmentsAfterDate":
                value = !this.state.userViewTreatmentsAfterDate;
                //this.setState({ userViewTreatmentsAfterDate: value });
                this.props.updateUserViewsDashboard(type, value);
                break;
            case "userViewAveragePain":
                value = !this.state.userViewAveragePain;
                //this.setState({ userViewAveragePain: value });
                this.props.updateUserViewsDashboard(type, value);
                break;
            case "userViewWoundsTypeDiagnosis":
                value = !this.state.userViewWoundsTypeDiagnosis;
                this.setState({ userViewWoundsTypeDiagnosis: value });
                this.props.updateUserViewsDashboard(type, value);
                break;
            case "userViewWoundsTypeGender":
                value = !this.state.userViewWoundsTypeGender;
                //this.setState({ userViewWoundsTypeGender: value });
                this.props.updateUserViewsDashboard(type, value);
                break;
            case "userViewNrDelayedTreatments":
                value = !this.state.userViewNrDelayedTreatments;
                //this.setState({ userViewNrDelayedTreatments: value });
                this.props.updateUserViewsDashboard(type, value);
                break;
            default:
                break;
        }
    }

    render() {
        var valueSpacePerc = 0;
        var valueSpaceUsed = this.state.spaceUsed || '0 MB';
        var valueSpaceAll = this.state.spaceAll || '10000 MB';
        if (isDefined(valueSpaceUsed) && isDefined(valueSpaceAll)) {
            let used = valueSpaceUsed.split(' ');
            let all = valueSpaceAll.split(' ');

            if (used.length > 0 && all.length > 0) {
                let usedValue = parseFloat(used[0]);
                let allValue = parseFloat(all[0]);

                if (allValue > 1000) {
                    valueSpaceAll = (allValue / 1000).toFixed(0) + ' GB';
                } else {
                    valueSpaceAll = allValue.toFixed(0) + ' ' + all[1];
                }
                if (usedValue > 1000) {
                    valueSpaceUsed = (usedValue / 1000).toFixed(2) + ' GB';
                } else {
                    valueSpaceUsed = usedValue.toFixed(2) + ' ' + used[1];
                }
                if (usedValue > allValue) {
                    valueSpacePerc = parseFloat(100);
                } else {
                    valueSpacePerc = parseFloat(
                        ((usedValue.toFixed(2) * 100) / allValue.toFixed(2)).toFixed(2)
                    );
                }
            }
        }

        const language = localStorage.getItem("i18nextLng") || "pt";

        //Data for graphs WoundsBytype
        let WoundsByTypeNumbers = [];
        let WoundsByTypeLabels = [];
        if (isDefined(this.state.WoundsByType)) {
            let t = this.state.WoundsByType.length;
            for (let i = 0; i < t; i++) {
                WoundsByTypeNumbers.push(this.state.WoundsByType[i].numWounds);
                WoundsByTypeLabels.push(this.state.WoundsByType[i].type);
            }
        }

        //Data for graphs AVG Pain by type
        let WoundsByTypePainNumbers = [];
        let WoundsByTypePainLabels = [];
        if (isDefined(this.state.WoundsByTypePain)) {
            let t = this.state.WoundsByTypePain.length;
            for (let i = 0; i < t; i++) {
                WoundsByTypePainNumbers.push(this.state.WoundsByTypePain[i].pain);
                WoundsByTypePainLabels.push(this.state.WoundsByTypePain[i].type);
            }
        }

        //Graph: Number pacients with exit date in episode with open wounds
        let pacientsWoundsOpenByTypeNumbers = [];
        let pacientsWoundsOpenByTypeLabels = [];
        if (isDefined(this.state.PacientsWoundsOpenByType)) {
            let t = this.state.PacientsWoundsOpenByType.length;
            for (let i = 0; i < t; i++) {
                pacientsWoundsOpenByTypeNumbers.push(this.state.PacientsWoundsOpenByType[i].numWounds);
                pacientsWoundsOpenByTypeLabels.push(this.state.PacientsWoundsOpenByType[i].type);
            }
        }

        //Graph PercentageByGender
        // Min, Max, Numbers, Labels
        let WoundsByTypeGenderNumbersMen = [];
        let WoundsByTypeGenderNumbersWomen = [];
        let WoundsByTypeGenderPercMen = [];
        let WoundsByTypeGenderPercWomen = [];
        let WoundsByTypeGenderLabels = [];
        let WoundsByTypeGenderMin = 0;
        let WoundsByTypeGenderMax = 0;
        let WoundsByTypeGenderSteps = 10;
        if (isDefined(this.state.WoundsByTypeGender)) {

            let t = this.state.WoundsByTypeGender.length;
            let count = 0;
            for (let i = 0; i < t; i++) {

                if (WoundsByTypeGenderLabels.includes(this.state.WoundsByTypeGender[i].type)) {
                    count = count + 1;
                } else {
                    WoundsByTypeGenderLabels.push(this.state.WoundsByTypeGender[i].type)
                    count = 1;
                }

                // Todos os registos têm que ter o masculino e feminino
                // Se não vem na api é porque o valor é 0
                if (count == 1) {
                    if (WoundsByTypeGenderNumbersWomen.length > WoundsByTypeGenderNumbersMen.length) {
                        // tem que adicionar
                        WoundsByTypeGenderNumbersMen.push(0)
                        WoundsByTypeGenderPercMen.push(0)
                    } else if (WoundsByTypeGenderNumbersMen.length > WoundsByTypeGenderNumbersWomen.length) {
                        WoundsByTypeGenderNumbersWomen.push(0)
                        WoundsByTypeGenderPercWomen.push(0)
                    }
                }

                if (this.state.WoundsByTypeGender[i].gender == 'Feminino' || this.state.WoundsByTypeGender[i].gender == 'F') {
                    WoundsByTypeGenderNumbersWomen.push(this.state.WoundsByTypeGender[i].numWounds)
                    WoundsByTypeGenderPercWomen.push(this.state.WoundsByTypeGender[i].percentage)
                } else {
                    WoundsByTypeGenderNumbersMen.push(this.state.WoundsByTypeGender[i].numWounds)
                    WoundsByTypeGenderPercMen.push(this.state.WoundsByTypeGender[i].percentage)
                }

                if (WoundsByTypeGenderMax < this.state.WoundsByTypeGender[i].numWounds) {
                    WoundsByTypeGenderMax = this.state.WoundsByTypeGender[i].numWounds
                }
            }
        }

        if (WoundsByTypeGenderNumbersWomen.length > WoundsByTypeGenderNumbersMen.length) {
            WoundsByTypeGenderNumbersMen.push(0)
            WoundsByTypeGenderPercMen.push(0)
        } else if (WoundsByTypeGenderNumbersMen.length > WoundsByTypeGenderNumbersWomen.length) {
            WoundsByTypeGenderNumbersWomen.push(0)
            WoundsByTypeGenderPercWomen.push(0)
        }

        if (WoundsByTypeGenderMax > 1000) {
            WoundsByTypeGenderSteps = 100
        } else if (WoundsByTypeGenderSteps > 500) {
            WoundsByTypeGenderSteps = 50
        } else if (WoundsByTypeGenderSteps > 200) {
            WoundsByTypeGenderSteps = 20
        }

        let resto = WoundsByTypeGenderMax % WoundsByTypeGenderSteps;
        if (resto > 0) {
            WoundsByTypeGenderMax = (WoundsByTypeGenderMax - resto) + WoundsByTypeGenderSteps
        }


        let InternmentWoundsLabels = [];
        let InternmentWoundsNumbers = [];
        if (isDefined(this.state.ListInternmentWounds)) {
            let t = this.state.ListInternmentWounds.length;
            for (let i = 0; i < t; i++) {
                InternmentWoundsNumbers.push(this.state.ListInternmentWounds[i].numWounds);
                InternmentWoundsLabels.push(this.state.ListInternmentWounds[i].type);
            }
        }

        let ListWoundsTimeLabels = [];
        let ListWoundsTimeValuesMin = [];
        let ListWoundsTimeValuesMax = [];
        let ListWoundsTimeValuesAvg = [];
        let ListWoundsTimeMin = 0;
        let ListWoundsTimeMax = 10;
        let ListWoundsTimeSteps = 10;
        if (isDefined(this.state.ListWoundsTime)) {
            let t = this.state.ListWoundsTime.length;
            for (let i = 0; i < t; i++) {
                ListWoundsTimeValuesMin.push(this.state.ListWoundsTime[i].timeMin);
                ListWoundsTimeValuesMax.push(this.state.ListWoundsTime[i].timeMax);
                ListWoundsTimeValuesAvg.push(this.state.ListWoundsTime[i].timeAvg);
                ListWoundsTimeLabels.push(this.state.ListWoundsTime[i].type);

                if (ListWoundsTimeMax < this.state.ListWoundsTime[i].timeMax) {
                    ListWoundsTimeMax = this.state.ListWoundsTime[i].timeMax
                }
            }
        }

        if (ListWoundsTimeMax > 1000) {
            ListWoundsTimeSteps = 100
        } else if (ListWoundsTimeMax > 500) {
            ListWoundsTimeSteps = 50
        } else if (ListWoundsTimeMax > 200) {
            ListWoundsTimeSteps = 20
        }

        resto = ListWoundsTimeMax % ListWoundsTimeSteps;
        if (resto > 0) {
            ListWoundsTimeMax = (ListWoundsTimeMax - resto) + ListWoundsTimeSteps
        }


        //WoundsByDiagnosis
        let ListWoundsDiagnosis = [];
        let listDataByTypology = [];
        let ListWoundsDiagnosisMin = 0;
        let ListWoundsDiagnosisMax = 10;
        let ListWoundsDiagnosisSteps = 1;
        //let colors = ['#F06292', '#9575CD', '#64B5F6', '#4DB6AC', '#FF8A65', '#7E57C2', '#26A69A', '#FFA726', '#F06292', '#9575CD', '#64B5F6']
        if (isDefined(this.state.WoundsByDiagnosis)) {
            let lenWoundsDiagnosis = this.state.WoundsByDiagnosis.length;
            let lastDiag = "";
            let listTypologis = [];
            for (let i = 0; i < lenWoundsDiagnosis; i++) {
                let diagnosisData = this.state.WoundsByDiagnosis[i]
                if (!listTypologis.includes(diagnosisData.typologyId)) {
                    let label = diagnosisData.type;

                    let indexColor = listDataByTypology.length;
                    let data = {
                        backgroundColor: colorsGraphs[indexColor],
                        borderColor: colorsGraphs[indexColor],
                        borderWidth: 1,
                        data: [],
                        hidden: false,
                        label: label,
                        fontSize: 27
                    }
                    listTypologis.push(diagnosisData.typologyId);
                    listDataByTypology.push(data);
                }

                if (lastDiag != diagnosisData.diagnosis) {
                    ListWoundsDiagnosis.push(diagnosisData.diagnosis);
                    lastDiag = diagnosisData.diagnosis;
                }
            }

            let lenData = listDataByTypology.length;
            let lenDiagnosis = ListWoundsDiagnosis.length;

            for (let t = 0; t < lenData; t++) {
                for (let d = 0; d < lenDiagnosis; d++) {
                    listDataByTypology[t].data[d] = 0;
                }
            }

            for (let t = 0; t < lenData; t++) {
                let sum = 0;
                for (let d = 0; d < lenDiagnosis; d++) {
                    for (let i = 0; i < lenWoundsDiagnosis; i++) {
                        let diagnosisData = this.state.WoundsByDiagnosis[i];
                        if (diagnosisData.typologyId == listTypologis[t] && diagnosisData.diagnosis == ListWoundsDiagnosis[d]) {
                            listDataByTypology[t].data[d] = diagnosisData.numWounds;
                        }
                    }
                    sum = sum + listDataByTypology[t].data[d];
                }
                if (sum > ListWoundsDiagnosisMax) {
                    ListWoundsDiagnosisMax = sum
                }
            }

            if (ListWoundsDiagnosisMax > 1000) {
                ListWoundsDiagnosisSteps = 100
            } else if (ListWoundsDiagnosisMax > 500) {
                ListWoundsDiagnosisSteps = 50
            } else if (ListWoundsDiagnosisMax > 200) {
                ListWoundsDiagnosisSteps = 20
            } else if (ListWoundsDiagnosisMax > 50) {
                ListWoundsDiagnosisSteps = 10
            }

            resto = ListWoundsDiagnosisMax % ListWoundsDiagnosisSteps;
            if (resto > 0) {
                ListWoundsDiagnosisMax = (ListWoundsDiagnosisMax - resto) + ListWoundsDiagnosisSteps
            }
        }


        //Data for graph InterventionsDelayed
        let InterventionsDelayedByTypeNumbers = [];
        let InterventionsDelayedByTypeLabels = [];
        if (isDefined(this.state.InterventionsDelayed)) {
            let t = this.state.InterventionsDelayed.length;
            for (let i = 0; i < t; i++) {
                InterventionsDelayedByTypeNumbers.push(this.state.InterventionsDelayed[i].numWounds);
                InterventionsDelayedByTypeLabels.push(this.state.InterventionsDelayed[i].type);
            }
        }

        //Data for graph Products By Type
        let ListWoundsProducts = [];
        let listDataProdByTypology = [];
        let ListWoundsProductsMin = 0;
        let ListWoundsProductsMax = 10;
        let ListWoundsProductsSteps = 1;

        if (isDefined(this.state.ListProductsByType)) {
            let lenWoundsProducts = this.state.ListProductsByType.length;
            let lastProd = "";
            let listTypologis = [];
            for (let i = 0; i < lenWoundsProducts; i++) {
                let productsData = this.state.ListProductsByType[i]

                if (!listTypologis.includes(productsData.typologyId)) {
                    let label = productsData.type;

                    let indexColor = listDataProdByTypology.length;
                    let data = {
                        backgroundColor: colorsGraphs[indexColor],
                        borderColor: colorsGraphs[indexColor],
                        borderWidth: 1,
                        data: [],
                        hidden: false,
                        label: label,
                        fontSize: 27
                    }
                    listTypologis.push(productsData.typologyId);
                    listDataProdByTypology.push(data);
                }

                if (lastProd != productsData.product) {
                    ListWoundsProducts.push(productsData.product);
                    lastProd = productsData.product;
                }
            }

            let lenData = listDataProdByTypology.length;
            let lenDiagnosis = ListWoundsProducts.length;

            for (let t = 0; t < lenData; t++) {
                for (let d = 0; d < lenDiagnosis; d++) {
                    listDataProdByTypology[t].data[d] = 0;
                }
            }

            for (let t = 0; t < lenData; t++) {
                for (let d = 0; d < lenDiagnosis; d++) {
                    for (let i = 0; i < lenWoundsProducts; i++) {
                        let productsData = this.state.ListProductsByType[i];
                        if (productsData.typologyId == listTypologis[t] && productsData.product == ListWoundsProducts[d]) {
                            listDataProdByTypology[t].data[d] = productsData.numWounds;
                        }
                    }
                }
            }

            if (lenWoundsProducts > 0) {
                ListWoundsProductsMax = this.state.ListProductsByType[0].numWoundsTotal;
            }

            if (ListWoundsProductsMax > 1000) {
                ListWoundsProductsSteps = 100
            } else if (ListWoundsProductsMax > 500) {
                ListWoundsProductsSteps = 50
            } else if (ListWoundsProductsMax > 200) {
                ListWoundsProductsSteps = 20
            } else if (ListWoundsProductsMax > 50) {
                ListWoundsProductsSteps = 10
            }

            resto = ListWoundsProductsMax % ListWoundsProductsSteps;
            if (resto > 0) {
                ListWoundsProductsMax = (ListWoundsProductsMax - resto) + ListWoundsProductsSteps
            }
        }

        if (this.state.selectedEstablishments.length > 0 && isDefined(this.state.establishments)) {
            let numEst = this.state.establishments.length;
            let numEstSel = this.state.selectedEstablishments.length;
            let exist = false;
            for (let e = 0; e < numEstSel; e++) {
                for (let f = 0; f < numEst; f++) {
                    if (this.state.selectedEstablishments[e].rowKey === this.state.establishments[f].rowKey) {
                        exist = true;
                        break;
                    }
                }
                if (exist) {
                    break;
                }
            }

            //se não existe é porque alterou a instituição
            // limpa todos os selecionados.
            if (!exist) {
                this.setState({
                    selectedEstablishments: []
                })
            }
        }

        return (
            <>
                <div id='back-to-top-anchor-dashboard'></div>
                {/* <LoadingF3M hidden={!this.state.isLoading} /> */}
                <DashboardPage
                    isLoading={this.state.isLoading}
                    acessSettings={this.state.acessSettings}
                    acessWounds={this.state.acessWounds}
                    spaceUsed={valueSpaceUsed}
                    spaceAll={valueSpaceAll}
                    spacePerc={valueSpacePerc}
                    numberOfLicenses={this.state.NumberOfUserLicense}
                    NumberOfPhotos={this.state.NumberOfPhotos}
                    NumberOfPacientsMen={this.state.NumberOfPacientsMen}
                    NumberOfPacientsWomen={this.state.NumberOfPacientsWomen}
                    NumberOfWounds={this.state.NumberOfWounds}
                    NumberOfWoundsOpen={this.state.NumberOfWoundsOpen}
                    NumberOfWoundsClosed={this.state.NumberOfWoundsClosed}
                    OnChangeFrom={this.handleChange('dateFrom')}
                    OnChangeTo={this.handleChange('dateTo')}
                    filterDateFrom={this.state.filterDateFromWounds}
                    filterDateTo={this.state.filterDateToWounds}
                    OnClearFilter={(type) => this.OnClearFilter(type)}
                    NumberOfWoundsAdmission={this.state.NumberOfWoundsAdmission}
                    NumberOfMonitorDelay={this.state.NumberOfMonitorDelay}
                    WoundsByTypeNumbers={WoundsByTypeNumbers}
                    WoundsByTypeLabels={WoundsByTypeLabels}
                    WoundsByTypePainNumbers={WoundsByTypePainNumbers}
                    WoundsByTypePainLabels={WoundsByTypePainLabels}
                    PacientsWoundsOpenByTypeNumbers={pacientsWoundsOpenByTypeNumbers}
                    PacientsWoundsOpenByTypeLabels={pacientsWoundsOpenByTypeLabels}
                    WoundsByTypeGenderNumbersMen={WoundsByTypeGenderNumbersMen}
                    WoundsByTypeGenderNumbersWomen={WoundsByTypeGenderNumbersWomen}
                    WoundsByTypeGenderPercMen={WoundsByTypeGenderPercMen}
                    WoundsByTypeGenderPercWomen={WoundsByTypeGenderPercWomen}
                    WoundsByTypeGenderLabels={WoundsByTypeGenderLabels}
                    WoundsByTypeGenderSteps={WoundsByTypeGenderSteps}
                    WoundsByTypeGenderMin={WoundsByTypeGenderMin}
                    WoundsByTypeGenderMax={WoundsByTypeGenderMax}
                    InternmentWoundsLabels={InternmentWoundsLabels}
                    InternmentWoundsNumbers={InternmentWoundsNumbers}
                    TimeOfStayingMax={ListWoundsTimeMax}
                    TimeOfStayingMin={ListWoundsTimeMin}
                    TimeOfStayingSteps={ListWoundsTimeSteps}
                    TimeOfStayingMaxValues={ListWoundsTimeValuesMax}
                    TimeOfStayingMinValues={ListWoundsTimeValuesMin}
                    TimeOfStayingAvgValues={ListWoundsTimeValuesAvg}
                    TimeOfStayingLabels={ListWoundsTimeLabels}
                    WoundsByDiagnosisLabels={ListWoundsDiagnosis}
                    WoundsByDiagnosisData={listDataByTypology}
                    WoundsByDiagnosisMin={ListWoundsDiagnosisMin}
                    WoundsByDiagnosisMax={ListWoundsDiagnosisMax}
                    WoundsByDiagnosisSteps={ListWoundsDiagnosisSteps}
                    InterventionsDelayedByTypeNumbers={InterventionsDelayedByTypeNumbers}
                    InterventionsDelayedByTypeLabels={InterventionsDelayedByTypeLabels}
                    WoundsByProductsLabels={ListWoundsProducts}
                    WoundsByProductsData={listDataProdByTypology}
                    WoundsByProductsMin={ListWoundsProductsMin}
                    WoundsByProductsMax={ListWoundsProductsMax}
                    WoundsByProductsSteps={ListWoundsProductsSteps}
                    establishments={this.state.establishments}
                    onChangeEstab={this.handleChange('Est')}
                    selectedEstablishments={this.state.selectedEstablishments}
                    userViewDiskSpace={this.state.userViewDiskSpace}
                    userViewNumberUsers={this.state.userViewNumberUsers}
                    userViewUsageLevels={this.state.userViewUsageLevels}
                    userViewNrWoundsAdmission={this.state.userViewNrWoundsAdmission}
                    userViewAverageWounds={this.state.userViewAverageWounds}
                    userViewTreatments={this.state.userViewTreatments}
                    userViewUnhealedWounds={this.state.userViewUnhealedWounds}
                    userViewWoundsHospitalization={this.state.userViewWoundsHospitalization}
                    userViewWoundsByType={this.state.userViewWoundsByType}
                    userViewTreatmentsAfterDate={this.state.userViewTreatmentsAfterDate}
                    userViewAveragePain={this.state.userViewAveragePain}
                    userViewWoundsTypeDiagnosis={this.state.userViewWoundsTypeDiagnosis}
                    userViewWoundsTypeGender={this.state.userViewWoundsTypeGender}
                    userViewNrDelayedTreatments={this.state.userViewNrDelayedTreatments}
                    onChangeView={(type) => this.OnChangeView(type)}
                />
                <BackToTop iddiv={'#back-to-top-anchor-dashboard'}></BackToTop>
            </>
        );
    }
}

const mapStateToProps = state => ({ login: state.login });
const mapDispatchToProps = dispatch =>
    bindActionCreators({ setLoading, getDashboard, getDashboardOnlyWounds, getEstablishments, updateUserViewsDashboard, getDashboardWithoutDiskSpace }, dispatch);
export default withTranslation()(connect(
    mapStateToProps,
    mapDispatchToProps
)(DashboardPages))


